
    import './styles.scoped.css';
    export default {
  "link": "awsui_link_1kosq_7xadb_3",
  "breadcrumb": "awsui_breadcrumb_1kosq_7xadb_7",
  "icon": "awsui_icon_1kosq_7xadb_10",
  "anchor": "awsui_anchor_1kosq_7xadb_14",
  "last": "awsui_last_1kosq_7xadb_50",
  "compressed": "awsui_compressed_1kosq_7xadb_60",
  "text": "awsui_text_1kosq_7xadb_64"
};
  